<template>
  <nav class="side-nav">
    <div class="side-nav__wrapper">
      <SideNavButton v-for="item in items" v-bind:data="item" v-bind:key="item.id"></SideNavButton>
      <!-- The Side Nav submenus temporarily here  -->
      <div class="side-nav__menu-sub">
        <router-link to="/">Sub Menu Link</router-link>
        <BaseIcon class="nav-buttons-side__icon" name="chevron_right" size="22"></BaseIcon>
      </div>
      <div class="side-nav__menu-sub-sub">
        <router-link to="/">Sub-Sub Menu ink</router-link>
        <BaseIcon class="nav-buttons-side__icon" name="chevron_right" size="22"></BaseIcon>
      </div>
    </div>
  </nav>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import SideNavButton from './SideNavButton.vue'

export default {
  name: 'SideNav',
  components: {
    SideNavButton,
    BaseIcon
  },
  data() {
    return {
      items: [
        {
          title: 'Financial Reports',
          mainlink: '/'
        },
        {
          title: 'Financial Calendar',
          mainlink: '/'
        },
        {
          title: 'Share Price',
          mainlink: '/'
        },
        {
          title: 'Analysts',
          mainlink: '/'
        },
        {
          title: 'Consensus',
          mainlink: '/'
        },
        {
          title: 'Shareholder Information',
          mainlink: '/'
        }
      ]
    }
  }
}
</script>

<style lang="postcss">
.side-nav {
  @apply text-primary;
}
.side-nav__wrapper {
  @apply mb-16;
}
.side-nav__menu-sub,
.side-nav__menu-sub-sub {
  @apply border border-t-0 border-l-0 border-r-0 border-body-lighter relative;
}
.side-nav__menu-sub a,
.side-nav__menu-sub-sub a {
  @apply block py-4 pr-4 text-body-light no-underline font-semibold;
}
.side-nav__menu-sub-sub a {
  @apply pl-4;
}
.side-nav__menu-sub a:hover,
.side-nav__menu-sub-sub a:hover {
  @apply text-primary;
}
.side-nav__menu-sub.current,
.side-nav__menu-sub.current a,
.side-nav__menu-sub-sub.current,
.side-nav__menu-sub-sub.current a {
  @apply text-body;
}
.side-nav__menu-sub .nav-buttons-side__icon,
.side-nav__menu-sub-sub .nav-buttons-side__icon {
  @apply hidden;
}
.side-nav__menu-sub.current .nav-buttons-side__icon,
.side-nav__menu-sub-sub.current .nav-buttons-side__icon {
  @apply block fill-current absolute right-0;
  top: calc(50% - 12px);
}
</style>

